var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "openTimeStyle",
          attrs: {
            title: _vm.title + "答疑",
            visible: _vm.dialog,
            width: "800px",
            id: "basis"
          },
          on: {
            "update:visible": function($event) {
              _vm.dialog = $event
            }
          },
          scopedSlots: _vm._u([
            {
              key: "footer",
              fn: function() {
                return [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        {
                          staticStyle: {
                            "padding-top": "10px",
                            "text-align": "left",
                            "font-size": "10px"
                          },
                          attrs: { span: 12 }
                        },
                        [
                          _vm._v(
                            "\n        温馨提示：尊敬的用户您好！本沟通平台的沟通次序保持一问一答的次序\n      "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        {
                          staticStyle: {
                            "padding-top": "10px",
                            "text-align": "right"
                          },
                          attrs: { span: 12 }
                        },
                        [
                          _c(
                            "el-button",
                            {
                              on: {
                                click: function($event) {
                                  _vm.dialog = false
                                }
                              }
                            },
                            [_vm._v("关闭")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: {
                                click: function($event) {
                                  return _vm.submit()
                                }
                              }
                            },
                            [_vm._v("发送")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.form.sendType == "reply",
                                  expression: "form.sendType == 'reply'"
                                }
                              ],
                              attrs: { type: "primary" },
                              on: {
                                click: function($event) {
                                  return _vm.submit("已查看")
                                }
                              }
                            },
                            [_vm._v("已查看")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              },
              proxy: true
            }
          ])
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                padding: "0 20px 30px 20px",
                "max-height": "500px",
                "min-height": "300px",
                overflow: "auto",
                border: "1px solid rgb(220, 223, 230)"
              }
            },
            _vm._l(_vm.tableData, function(item, index) {
              return _c(
                "div",
                { key: index, attrs: { index: item.path } },
                [
                  item.empFlag == false
                    ? _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            {
                              staticStyle: {
                                "text-align": "left",
                                "padding-top": "10px"
                              },
                              attrs: { span: 24 }
                            },
                            [
                              _c(
                                "div",
                                { staticStyle: { display: "flex" } },
                                [
                                  _c("el-image", {
                                    staticStyle: {
                                      height: "30px",
                                      width: "30px"
                                    },
                                    attrs: { src: _vm.imgLeft }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "p",
                                    {
                                      staticStyle: {
                                        "line-height": "30px",
                                        "padding-left": "10px"
                                      }
                                    },
                                    [_vm._v(_vm._s(item.senderName))]
                                  ),
                                  _vm._v("\n                \n              "),
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            !item.parentId &&
                                            _vm.title == "送货中",
                                          expression:
                                            "!item.parentId && title == '送货中'"
                                        }
                                      ],
                                      staticClass: "label-qus"
                                    },
                                    [_vm._v("提问")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            item.parentId &&
                                            _vm.title == "送货中",
                                          expression:
                                            "item.parentId && title == '送货中'"
                                        }
                                      ],
                                      staticClass: "label-qus"
                                    },
                                    [_vm._v("答疑")]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              item.fileSuffix == "图片"
                                ? _c("el-image", {
                                    staticClass: "img",
                                    staticStyle: { "padding-left": "35px" },
                                    attrs: {
                                      src: item.fileUrl,
                                      "preview-src-list": [item.fileUrl],
                                      fit: "cover"
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              item.fileSuffix == "文件"
                                ? _c(
                                    "a",
                                    {
                                      staticStyle: {
                                        "text-decoration": "none",
                                        color: "#007AFF",
                                        "padding-left": "35px"
                                      },
                                      attrs: { href: item.fileUrl }
                                    },
                                    [_vm._v(_vm._s(item.fileName))]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              item.fileSuffix == "文字"
                                ? _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        color: "rgb(10, 127, 255)",
                                        "padding-left": "35px"
                                      }
                                    },
                                    [_vm._v(_vm._s(item.content))]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c("br"),
                              _c(
                                "span",
                                { staticStyle: { "padding-left": "35px" } },
                                [_vm._v(_vm._s(item.createAt))]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  item.empFlag == true
                    ? _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            {
                              staticStyle: {
                                "padding-top": "20px",
                                "text-align": "right"
                              },
                              attrs: { span: 24 }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "justify-content": "flex-end"
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: { "padding-right": "20px" }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            "justify-content": "flex-end"
                                          }
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value:
                                                    !item.parentId &&
                                                    _vm.title == "送货中",
                                                  expression:
                                                    "!item.parentId && title == '送货中'"
                                                }
                                              ],
                                              staticClass: "label-qus"
                                            },
                                            [_vm._v("提问")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value:
                                                    item.parentId &&
                                                    _vm.title == "送货中",
                                                  expression:
                                                    "item.parentId && title == '送货中'"
                                                }
                                              ],
                                              staticClass: "label-qus"
                                            },
                                            [_vm._v("答疑")]
                                          ),
                                          _vm._v(
                                            "\n                    \n                  "
                                          ),
                                          _c("p", [
                                            _vm._v(_vm._s(item.senderName))
                                          ])
                                        ]
                                      ),
                                      _vm._v(" "),
                                      item.fileSuffix == "图片"
                                        ? _c("el-image", {
                                            staticClass: "img",
                                            staticStyle: {
                                              "padding-left": "35px"
                                            },
                                            attrs: {
                                              src: item.fileUrl,
                                              "preview-src-list": [
                                                item.fileUrl
                                              ],
                                              fit: "cover"
                                            }
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      item.fileSuffix == "文件"
                                        ? _c(
                                            "a",
                                            {
                                              staticStyle: {
                                                "text-decoration": "none",
                                                color: "#007AFF"
                                              },
                                              attrs: { href: item.fileUrl }
                                            },
                                            [_vm._v(_vm._s(item.fileName))]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      item.fileSuffix == "文字"
                                        ? _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                color: "rgb(10, 127, 255)"
                                              }
                                            },
                                            [_vm._v(_vm._s(item.content))]
                                          )
                                        : _vm._e(),
                                      _c("br"),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(_vm._s(item.createAt))
                                      ])
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("el-image", {
                                    staticStyle: {
                                      height: "30px",
                                      width: "30px"
                                    },
                                    attrs: { src: _vm.imgRight }
                                  })
                                ],
                                1
                              )
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            }),
            0
          ),
          _vm._v(" "),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                {
                  staticStyle: { "padding-top": "10px", "text-align": "left" },
                  attrs: { span: 4 }
                },
                [
                  _c(
                    "el-upload",
                    {
                      ref: "upload",
                      attrs: {
                        action: "#",
                        accept: ".png,.jpg",
                        "on-change": _vm.uploadImg,
                        limit: 1,
                        "on-exceed": function() {
                          return _vm.$message.error("请删除后在上传")
                        },
                        "on-remove": function() {
                          return _vm.removeImg()
                        },
                        "file-list": _vm.imgList,
                        "auto-upload": false
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "align-items": "center"
                          }
                        },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                icon: "el-icon-picture-outline",
                                type: "text",
                                disabled: _vm.imgShow
                              }
                            },
                            [_vm._v("图片")]
                          )
                        ],
                        1
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                {
                  staticStyle: { "padding-top": "10px", "text-align": "left" },
                  attrs: { span: 20 }
                },
                [
                  _c(
                    "el-upload",
                    {
                      ref: "upload",
                      attrs: {
                        action: "#",
                        accept: ".doc,.docx,.pdf",
                        "on-change": _vm.uploadFile,
                        limit: 1,
                        "on-exceed": function() {
                          return _vm.$message.error("请删除后在上传")
                        },
                        "on-remove": function() {
                          return _vm.removeFile()
                        },
                        "file-list": _vm.fileList,
                        "auto-upload": false
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "align-items": "center"
                          }
                        },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                icon: "el-icon-folder-opened",
                                type: "text",
                                disabled: _vm.fileShow
                              }
                            },
                            [_vm._v("文件")]
                          )
                        ],
                        1
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                {
                  staticStyle: { "padding-top": "10px", "text-align": "left" },
                  attrs: { span: 24 }
                },
                [
                  _c("el-input", {
                    staticClass: "border-none",
                    attrs: {
                      type: "textarea",
                      rows: 2,
                      placeholder: "请输入",
                      disabled: _vm.contentShow
                    },
                    on: {
                      change: function($event) {
                        return _vm.getDisType()
                      }
                    },
                    model: {
                      value: _vm.form.content,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "content", $$v)
                      },
                      expression: "form.content"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "openTimeStyle",
          attrs: {
            title: "温馨提示",
            visible: _vm.dialogV2,
            width: "700px",
            id: "basis"
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogV2 = $event
            }
          },
          scopedSlots: _vm._u([
            {
              key: "footer",
              fn: function() {
                return [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        {
                          staticStyle: { "text-align": "center" },
                          attrs: { span: 24 }
                        },
                        [
                          _c(
                            "el-button",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.submitv2()
                                }
                              }
                            },
                            [_vm._v("关闭")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              },
              proxy: true
            }
          ])
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                padding: "10px 0 0 0",
                width: "100%",
                "text-align": "center"
              }
            },
            [
              _vm._v(
                "\n      尊敬的用户您好！该标段报价截止时间已到，答疑功能关闭，点击【知道了】待办自动消除\n    "
              )
            ]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }